<zn-stepper-wizard
  [stepDefinitions]="stepDefinitions"
  [storageKey]="storageKey"
  [finalActionLabelKey]="finalActionLabelKey"
  (submitWizardData)="onSubmitWizard($event)"
  (cancelWizard)="onCancel()"
/>

<lib-stepper-success-modal
  [isVisible]="successModalVisible()"
  [message]="successMessageKey"
  (isVisibleChange)="onSuccessModalVisibleChange($event)"
/>
